var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('line-chart',{attrs:{"chart-data":_vm.chartData,"options":_vm.chartOption,"height":_vm.chartHeight}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }